/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BrandingConfiguration {
    getFixupPrototypeFunction() { return BrandingConfiguration.fixupPrototype; }

    static newInstance(model: Partial<BrandingConfiguration>): BrandingConfiguration {
        let obj = Object.assign(new BrandingConfiguration(), model);
        BrandingConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BrandingConfiguration>): BrandingConfiguration {
        if (!model) return null;
        return BrandingConfiguration.newInstance(<BrandingConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BrandingConfiguration) {
        if (!obj) return;

        models.BrandingConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BrandingConfiguration): boolean {
        Object.setPrototypeOf(obj, BrandingConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    primaryColor: string;

    secondaryColor: string;

    text: string;

    logoBase64: string;

    horizontalPlacement: models.HorizontalAlignment;

    verticalPlacement: models.VerticalAlignment;

}
